/** The avatar menu at the right of the top bar: who is signed in, Admin, Sign out. */
import { useLocation } from "react-router-dom";
import { clsx } from "clsx";

import { signOut, useAuth } from "../../hooks/useAuth";
import { useToast } from "../toast/context";
import { Menu, MenuItem, MenuLabel, MenuLink, MenuSeparator } from "../ui/Menu";
import { useMenuTrigger } from "../ui/useMenuTrigger";

export function UserMenu() {
  const { username, email, isAdmin } = useAuth();
  const { pathname } = useLocation();
  const menu = useMenuTrigger();
  const toast = useToast();
  const onAdmin = pathname === "/admin" || pathname.startsWith("/admin/");
  return (
    <>
      <button
        {...menu.triggerProps}
        className={clsx("user-chip", onAdmin && "is-active")}
        aria-label={`Account: ${email ?? username ?? "signed in"}`}
      >
        <span className="avatar">{username?.[0]?.toUpperCase() ?? "?"}</span>
        <span className="user-chip-name">{username ?? "…"}</span>
        <span className="topbar-caret" aria-hidden>
          ▾
        </span>
      </button>
      <Menu
        open={menu.open}
        onClose={() => menu.setOpen(false)}
        anchorRef={menu.triggerRef}
        id={menu.menuId}
        aria-label="Account"
        placement="bottom-end"
        focus={menu.edge}
      >
        <MenuLabel>
          <span className="block text-ink font-semibold">{username ?? "Signed in"}</span>
          {email ? <span className="block font-mono">{email}</span> : null}
        </MenuLabel>
        <MenuSeparator />
        {isAdmin === true ? <MenuLink to="/admin">Admin</MenuLink> : null}
        <MenuItem
          onSelect={() => {
            signOut().catch((e) => toast.error(e));
          }}
        >
          Sign out
        </MenuItem>
      </Menu>
    </>
  );
}
